import { useMemo } from "react";
import { useSelectorApp } from "../lib/redux";
import { useMetaAccountsLists } from "./useMetaAccountsLists";
import { buildSharePlatformAccounts } from "../utils/sharePlatformAccounts";

export const useSharePlatformAccounts = () => {
  const { isLoading, integrations } = useSelectorApp((state) => state.user);
  const { uniqueInstagramBusinessList, uniqueFacebookPagesList } =
    useMetaAccountsLists();

  const accounts = useMemo(
    () =>
      buildSharePlatformAccounts({
        integrations,
        uniqueInstagramBusinessList,
        uniqueFacebookPagesList,
      }),
    [integrations, uniqueFacebookPagesList, uniqueInstagramBusinessList]
  );

  return {
    accounts,
    isLoading,
  };
};
